module.exports = __webpack_public_path__ + "static/media/ar-SA.12b51b96.md";